
(() => {
  // Disable right-click context menu
  document.addEventListener('contextmenu', (event) => {
    event.preventDefault();
  });

  // Block common DevTools and source-view shortcuts
  document.addEventListener('keydown', (event) => {
    const key = event.key.toLowerCase();

    const blocked =
      key === 'f12' ||
      (event.ctrlKey && event.shiftKey && ['i', 'j', 'c'].includes(key)) ||
      (event.ctrlKey && key === 'u') ||
      (event.metaKey && event.altKey && ['i', 'j', 'c'].includes(key));

    if (blocked) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
})();
